// ============================================================
// Merkezi API adresleri.
// ============================================================

// 1) OData (mobil uygulamanin da kullandigi PORTSUZ asil API).
//    Panel'in okuma/yazma cagrilari kademeli olarak buraya tasinacak.
//    NOT: Tarayicidan cagrilabilmesi icin OData'da CORS acik olmali
//    (Global.asax.cs -> Application_BeginRequest eklendi, deploy gerekiyor).
export const ODATA_BASE = "https://berlinapi.stechomeyazilim.info";

// 2) Eski express wrapper (server.js, :9093).
//
//    ⚠️ BU SUNUCU ARTIK CALISMIYOR (baglanti reddediliyor) ve Berlin'in HICBIR
//    sayfasi artik bunu kullanmiyor — 2026-08-16'da hepsi ODATA_BASE'e tasindi.
//    Geriye kalan referanslar baska projelerden (Mega/Nefes/Luxun/Castor/Port)
//    kalma sablon artiklari; Berlin menusunden erisilemiyor.
//
//    YENI KOD YAZARKEN BUNU KULLANMAYIN — ODATA_BASE kullanin.
//    server.js zaten sadece OData'ya vekillik ediyordu, araya girmesine gerek yok.
export const API_BASE = "https://berlinadmin.stechomeyazilim.info:9093";

// 3) Resim/dosya yukleme servisi (kullanici istegi: bu PORTLU kalacak).
export const UPLOAD_BASE = "https://berlinadmin.stechomeyazilim.info:9091";

// 4) Yuklenen dosyalarin servis edildigi (portsuz) gorsel adresi.
export const MEDIA_BASE = "https://megasubdomain.stechomeyazilim.info";

export default API_BASE;

// ------------------------------------------------------------
// PUSH BILDIRIMI
//
// Panelin "Bildirimler" ekrani Notification tablosuna satir yaziyor;
// bu satir kullanicinin uygulamadaki ZIL IKONUNDA gorunuyor. Telefon
// ekraninda beliren push bildirimi ise ayri bir istek gerektiriyor:
// backend'deki /api/push ucu (BesApi -> Controllers/PushController.cs).
//
// PUSH_ANAHTAR, ucun bekledigi X-Push-Anahtar basligidir ve sunucudaki
// Web.config -> PushGizliAnahtar degeriyle AYNI olmali.
//
// NOT: Panel tarayicida calistigi icin bu anahtar son kullaniciya
// gorunur. Panel yalnizca yetkili kisilerin erisebildigi bir adreste
// durdugu icin kabul edilebilir; daha siki bir cozum istenirse istek
// panelin kendi sunucusu uzerinden vekillenmeli.
// ------------------------------------------------------------
export const PUSH_BASE = `${ODATA_BASE}/api/push`;
export const PUSH_ANAHTAR = process.env.REACT_APP_PUSH_ANAHTAR || "";
